import React from 'react';
import { getCurrencySymbol } from 'src/lib/utils';
import { Coupon } from 'src/pages/deprecated/payment/types';
import colors from 'src/styles/equalution/colors';

interface CouponProps {
  coupon: Coupon;
  couponCode: string;
}
const GenerateCouponText = (props: CouponProps): JSX.Element => {
  const { coupon, couponCode } = props;
  if (couponCode === 'EOFY50') {
    // EOFY50 is a special case
    return (
      <div>
        Promo code <strong>EOFY50</strong> applied for a{' '}
        <strong>50% discount</strong> on your first payment of your
        subscription.
      </div>
    );
  }

  const baseStyle = {
    color: colors.SALAD,
    fontSize: '12px',
    marginTop: '-8px',
    marginLeft: '4px',
    lineHeight: '16px',
  };

  // skipNextCycle promos don't discount cycle 1, they make the next billing cycle free
  if (coupon.metadata?.skipNextCycle === 'true') {
    return (
      <div style={baseStyle}>
        <strong>{couponCode}</strong> applied - your next billing cycle will be{' '}
        <strong>free</strong>.
      </div>
    );
  }

  const discountText =
    coupon.amountOff > 0
      ? `${getCurrencySymbol()}${coupon.amountOff / 100}`
      : coupon.percentOff > 0
      ? `${coupon.percentOff}%`
      : '';

  if (couponCode === 'GET3FREE' && coupon.percentOff === 50) {
    return (
      <div style={baseStyle}>
        <strong>GET3FREE</strong> successfully applied as a{' '}
        <strong>{coupon.percentOff}% discount</strong>. Enjoy 3 months of your 6
        month plan free.
      </div>
    );
  }

  return (
    <div style={baseStyle}>
      <strong>{couponCode}</strong> successfully applied for a{' '}
      <strong>{discountText}</strong> discount.
    </div>
  );
};

export default GenerateCouponText;
